// Hero carousel slide configuration
// You can easily update the images and content here

export interface HeroSlide {
  id: number;
  imageUrl: string;
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 1,
    imageUrl: '/images/carousel/hero-blonde-runner.jpg',
    title: '',
    subtitle: 'Extend your lifespan',
    ctaText: 'Start Your Journey',
    ctaLink: '/register'
  },
  {
    id: 2,
    imageUrl: '/images/carousel/hero-slide-2.jpg',
    title: '',
    subtitle: 'Use time effectively',
    ctaText: 'Explore Health Tree',
    ctaLink: '/register'
  },
  {
    id: 3,
    imageUrl: '/images/carousel/pexels-yankrukov-8436589.jpg',
    title: 'Build Healthy Habits',
    subtitle: 'Scientifically validated for optimal health',
    ctaText: 'Learn More',
    ctaLink: '/register'
  },
  {
    id: 4,
    imageUrl: '/images/carousel/pexels-cottonbro-9292814.jpg',
    title: 'Every step together',
    subtitle: 'Daily and weekly reminders and analytics reporting',
    ctaText: 'Get Started',
    ctaLink: '/register'
  },
  {
    id: 5,
    imageUrl: '/images/carousel/hero-5.jpg',
    title: 'Advanced Analytics',
    subtitle: 'Track your progress over time',
    ctaText: 'Join Now',
    ctaLink: '/register'
  }
];

// Instructions for updating images:
// 1. Add your new image to /client/public/images/carousel/
// 2. Update the imageUrl to point to your new image (e.g., '/images/carousel/your-image.jpg')
// 3. Images should be high quality and at least 1600x900 pixels
// 4. Recommended format: JPEG for photos, PNG for graphics with transparency
// 5. Update the title, subtitle, and CTA text to match your image content
// 6. The ctaLink should point to the appropriate page (/register, /pricing, etc.)

// Current images stored locally:
// - hero-blonde-runner.jpg: Professional blonde woman running with fitness tracking data overlay
// - hero-2.jpg: Progress tracking theme
// - hero-3.jpg: Strength training theme
// - hero-4.jpg: Healthy food theme
// - hero-5.jpg: Yoga/meditation theme